import { reportException } from 'src/exceptionReporting';
import { isNotEmpty } from './hasValue';

export const base64Encode = (data: any) => {
  const objJsonStr = JSON.stringify(data);
  return Buffer.from(objJsonStr).toString('base64');
};

export const base64Decode = (data: any) => {
  try {
    return isNotEmpty(data) && JSON.parse(Buffer.from(data, 'base64').toString('utf8'));
  } catch (err) {
    reportException(`<----base64-13----> ${err}`)
    return {}
  }
};
